import React from 'react';

interface SkrTokenIconProps {
  size?: number;
  style?: React.CSSProperties;
}

export const SkrTokenIcon: React.FC<SkrTokenIconProps> = ({ size = 16, style }) => (
  <img
    src="https://coin-images.coingecko.com/coins/images/70974/small/seeker-logo.jpg?1764922774"
    alt="SKR"
    style={{
      width: size,
      height: size,
      borderRadius: '50%',
      objectFit: 'cover',
      flexShrink: 0,
      background: 'rgba(139,92,246,0.3)',
      ...style,
    }}
  />
);
